'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LocalizationContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _en = require('react-intl/locale-data/en');

var _en2 = _interopRequireDefault(_en);

var _ru = require('react-intl/locale-data/ru');

var _ru2 = _interopRequireDefault(_ru);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _i18n = require('../../selectors/i18n');

var _i18n2 = require('../../actions/i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactIntl.addLocaleData)(_ru2.default);
(0, _reactIntl.addLocaleData)(_en2.default);

function mapStateToProps(state) {
    var languageKey = (0, _i18n.selectLanguageKey)(state);
    var translationList = (0, _i18n.selectTranslationList)(state);
    var languageList = (0, _i18n.selectLanguageList)(state);
    var defaultLanguageKey = (0, _i18n.selectDefaultLanguageKey)(state);

    return {
        defaultLanguageKey: defaultLanguageKey,
        languageKey: languageKey,
        languageList: languageList,
        translationList: translationList
    };
}

function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        changeLanguage: _i18n2.changeLanguage,
        loadLanguageList: _i18n2.loadLanguageList
    }, dispatch);
}

var Localization = function (_Component) {
    _inherits(Localization, _Component);

    function Localization() {
        _classCallCheck(this, Localization);

        return _possibleConstructorReturn(this, (Localization.__proto__ || Object.getPrototypeOf(Localization)).apply(this, arguments));
    }

    _createClass(Localization, [{
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _props, loadLanguageList, changeLanguage, defaultLanguageKey, languageKey, initWithDefault;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _props = this.props, loadLanguageList = _props.loadLanguageList, changeLanguage = _props.changeLanguage, defaultLanguageKey = _props.defaultLanguageKey, languageKey = _props.languageKey, initWithDefault = _props.initWithDefault;
                                _context.next = 3;
                                return loadLanguageList();

                            case 3:
                                if (initWithDefault) {
                                    changeLanguage(languageKey || defaultLanguageKey);
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                languageKey = _props2.languageKey,
                languageList = _props2.languageList,
                defaultLanguageKey = _props2.defaultLanguageKey,
                translationList = _props2.translationList;


            if (!Object.keys(languageList).length) {
                return null;
            }

            return _react2.default.createElement(
                _reactIntl.IntlProvider,
                {
                    defaultLocale: defaultLanguageKey,
                    key: [languageKey, Object.values(translationList)],
                    locale: languageKey,
                    messages: translationList
                },
                children
            );
        }
    }]);

    return Localization;
}(_react.Component);

Localization.defaultProps = {
    initWithDefault: true
};


var LocalizationContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Localization);

exports.LocalizationContainer = LocalizationContainer;